import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MuiModule } from '@move/ui';
import { TranslateModule } from '@ngx-translate/core';
import { MmuWidgetConfigurationDialog } from './widget-configuration-dialog/mmu-widget-configuration-dialog.component';
import { MmuRemoteWidgetConfigurationDialog } from './widget-configuration-dialog/mmu-remote-widget-configuration-dialog.component';

@NgModule({
  declarations: [MmuWidgetConfigurationDialog, MmuRemoteWidgetConfigurationDialog],
  imports: [CommonModule, MuiModule, ReactiveFormsModule, TranslateModule],
  exports: [MmuWidgetConfigurationDialog, MmuRemoteWidgetConfigurationDialog]
})
export class MmuDashboardModule {}
